var exports = {
  "Q": "CtaBannerSection__ycajQI",
};

module.exports = exports;
